import { Components, popoverClasses, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiPopover to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/popover/#css
 */
export const MuiPopover: Components<Theme>['MuiPopover'] = {
  defaultProps: {
    // Fix accessibility violation: prevent aria-hidden on backdrop
    // so that focusable menu items inside don't violate WCAG guidelines
    componentsProps: {
      backdrop: {
        'aria-hidden': false,
      },
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      [`& .${popoverClasses.paper}`]: {
        borderRadius: theme.featureFlags.panwRebrandStubYear ? theme.shape.borderRadiusMd : theme.shape.borderRadius,
        backgroundColor: theme.palette.background.popover,
        // Popovers render in a portal under `body`, outside Cloud's `#root` where colorScheme is set.
        // Without this, scrollbars stay on the light scheme.
        colorScheme: theme.palette.mode,
        // In dark mode, MUI v5 adds a background image with opacity that
        // matches the elevation, so turn that off for popovers
        ...(theme.palette.mode === 'dark' && { backgroundImage: 'unset' }),
      },
    }),
  },
};
